










































































































































import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { isEmoji, validateMessage } from '@/utils'
import postAppMessage, { MessageHandlers } from '@/utils/poster'
import { HeaderMap, Style } from '@/constants/figurePainting'
import { FigurePaintingForm } from '@/interfaces/figurePainting'

import PaintStyleOptions from './components/PaintStyleOptions.vue'
import PaintColorOptions from './components/PaintColorOptions.vue'
import PaintBodyOptions from './components/PaintBodyOptions.vue'
import PaintFrameOptions from './components/PaintFrameOptions.vue'
import PaintFrameSizeOptions from './components/PaintFrameSizeOptions.vue'

export default Vue.extend({
  name: 'FigurePaintingForm',
  components: {
    PaintStyleOptions,
    PaintColorOptions,
    PaintBodyOptions,
    PaintFrameOptions,
    PaintFrameSizeOptions
  },
  created () {
    postAppMessage(MessageHandlers.UPDATE_HEADER, HeaderMap.FORM)
  },
  computed: {
    form (): FigurePaintingForm {
      return this.$store.state.figurePainting.form
    },
    peopleOptions (): any {
      return new Array(30)
        .fill('')
        .map((_, idx) => ({
          id: idx + 1,
          value: idx + 1,
          text: `${idx + 1}位 $${this.currentPricing * (idx + 1)}`
        }))
    },
    paintOptions (): any {
      return new Array(100)
        .fill('')
        .map((_, idx) => ({
          id: idx + 1,
          value: idx + 1,
          text: `${idx + 1}個`
        }))
    },
    ...mapGetters('figurePainting', [
      'preview',
      'hasFrame',
      'currentPricing',
      'pricePerPeople'
    ])
  },
  methods: {
    ...mapActions('figurePainting', [
      'handleFormUpdate'
    ]),
    handleNextStep () {
      const errors = []
      const {
        form: { text },
        $route: { query }
      } = this
      if (text.length) {
        if (isEmoji(text)) {
          errors.push('無法使用表情符號')
        } else {
          const illegalChars = validateMessage(text)
          if (illegalChars.length) {
            errors.push('以下文字不支援。')
            errors.push(illegalChars)
          } else if (text.length > 50) {
            errors.push('超過字數限制')
          }
        }
      }

      if (errors.length) {
        this.$bvModal.msgBoxOk(
          errors.map(error => this.$createElement(
            'p',
            { class: ['text-center', 'mt-2', 'mb-0'] },
            error
          )),
          {
            centered: true,
            footerClass: 'msgbox-ok-footer',
            okTitle: '確定'
          }
        )
      } else {
        this.$router.push({ path: 'summary', query })
      }
    }
  }
})
